export default __webpack_public_path__ + "static/media/avatar_not_found.b92fe806.svg";